
import { useMediaQuery } from '@mui/material';
import { useState, useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { useDataProvider, useResourceContext } from "react-admin";
import InputFieldCustom from '../Commons/InputFieldCustom'
import InternalMenu from '../Commons/InternalMenu';
import credits from '../Commons/Icons/creditos.svg';
import fail from '../Commons/Icons/faild.svg';
import pay from '../Commons/Icons/pay.svg';
import book from '../Commons/Icons/book.svg';
import stats from '../Commons/Icons/stats.svg';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import historyTracker from '../Commons/historyTracker';
import States from '../Commons/States';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import AuthNotification from '../Commons/AuthNotification';
import BreadCrumbCustom from '../Commons/BreadCrum';
import { Style } from '../Commons/Styles.jsx';
import BottomToolBar from '../Commons/BottomToolBar';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchCompanyOrgToken, resolveCompanyOrgId, hasPermissions } from '../Commons/CompanyAuth';

const RequestShow = (props) => {
    const { id } = useParams();
    const resource = useResourceContext();
    const { getAccessTokenWithPopup } = useAuth0();
    const [openerror, setOpenerror] = useState(false);
    const [auth, setAuth] = useState(false);
    const [state, setState] = useState({});
    // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
    // "initialLoading" en el return): esta pantalla necesita traer el registro de la
    // compañia y los permisos antes de poder mostrar el formulario, y sin este estado
    // la ventana se veia en blanco (solo el breadcrumb) durante esa espera.
    const [initialLoading, setInitialLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const dataProvider = useDataProvider();
    let isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const handleRedirectFail = () => {
        navigate(`/reports/downpayment/fail`);
    };

    const handleRedirectPortfolio = () => {
        navigate(`/reports/downpayment/portfolio`);
    };

    const handleRedirectPayments = () => {
        navigate(`/reports/downpayment/payments`);
    };

    const handleRedirectAnalysis = () => {
        navigate(`/reports/downpayment/analysis`);
    };

    const [openDownPayments, setOpeDownPayments] = useState(true);

    const handleClickOpenDownPayments = () => {
        setOpeDownPayments(!openDownPayments);
    };

    const menus = [{
        icon: <img src={credits} alt="logo" style={Style.MenuLogo} />, name: 'Enganches',
        open: openDownPayments,
        openAction: handleClickOpenDownPayments,
        actions: [
            { icon: <img src={fail} alt="logo" style={Style.MenuLogo} />, name: 'Rescindidos/Rechazados', onClick: handleRedirectFail },
            { icon: <img src={book} alt="logo" style={Style.MenuLogo} />, name: 'Saldos Cartera', onClick: handleRedirectPortfolio },
            { icon: <img src={pay} alt="logo" style={Style.MenuLogo} />, name: 'Pagos', onClick: handleRedirectPayments },
            { icon: <img src={stats} alt="logo" style={Style.MenuLogo} />, name: 'Análisis Completo', onClick: handleRedirectAnalysis },
        ]
    }]

    useEffect(() => {
        (async () => {
            try {
                // Resuelve primero el org_id de Auth0 de ESTA Empresa (empresas.
                // ID_Organizacion_AUTH0, ya no un valor quemado -- ver CompanyAuth.js) y
                // recien con eso pide el token scoped a la organizacion, ANTES de traer
                // cualquier otra cosa: el API exige el permiso correspondiente en bloqueo
                // estricto para practicamente todos los endpoints (ver CompanyAuth.js), asi
                // que hace falta tener el token puesto en States antes de que esta pantalla
                // -- o cualquier otra a la que se navegue desde aca -- empiece a llamar al API.
                // resolveCompanyOrgId es seguro de llamar aca (sin token scoped todavia): usa
                // el mismo endpoint que ya usa CompaniesList.jsx, pensado para llamarse ANTES
                // de elegir una Empresa.
                const orgId = await resolveCompanyOrgId(dataProvider, resource, id);
                await fetchCompanyOrgToken(getAccessTokenWithPopup, orgId);

                let record = await dataProvider.getOne(resource, { id: id });
                historyTracker.addPath(location.pathname, record.data.name, 1);
                States.setNIT(record.data.nit);
                if (record.data.nit) {
                    const { data } = { data: hasPermissions('Company', 'read') };
                    if (data.length > 0) {
                        setAuth(data[0]);
                        setOpenerror(!data[0]);
                        if (data[0]) {
                            setState(record.data);
                            States.setCompany(record.data.company);
                        }
                    } else {
                        setAuth(false);
                        setOpenerror(true)
                    }
                }
            }
            catch {
            }
            finally {
                setInitialLoading(false);
            }
        })();
    }, [dataProvider, id, resource, location.pathname, getAccessTokenWithPopup]);

    return (
        <div class="container">
            <BreadCrumbCustom history={historyTracker.getHistory()} />
            {initialLoading ? (
                // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
                // el mismo CircularProgress que ya se usaba en las demas pantallas para el
                // guardado, pero aqui cubre la espera del registro de la compañia + permisos,
                // que antes dejaba la pantalla en blanco.
                <div class="Loading" style={{ display: 'block' }}>
                    <CircularProgress size="15rem" />
                </div>
            ) : auth ? (
                <div class="edit">
                    {!isSmall ? (
                        <div class="container" style={{ width: '100%', marginLeft: '0em' }}>
                            <div class="row">
                                <div class="col-3">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled
                                                checked={state?.creditSalesParameters}
                                                color="primary"
                                            />}
                                        label={
                                            <Typography style={Style.FilterLabel}>Ventas Créditos
                                            </Typography>
                                        }
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled
                                                checked={state?.dispatch}
                                                color="primary"
                                            />}
                                        label={
                                            <Typography style={Style.FilterLabel}>Despacho
                                            </Typography>
                                        }
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled
                                                checked={state?.overPricing}
                                                color="primary"
                                            />}
                                        label={
                                            <Typography style={Style.FilterLabel}>Sobre Precio
                                            </Typography>
                                        }
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                disabled
                                                checked={state?.reservItems}
                                                color="primary"
                                            />}
                                        label={
                                            <Typography style={Style.FilterLabel}>Reservar Artículos
                                            </Typography>
                                        }
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.company} label="Código" readOnly={true} />
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.name} label="Nombre" readOnly={true} />
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.nit} label="NIT" readOnly={true} />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.address} label="Dirección" readOnly={true} />
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.address2} label="Dirección 2" readOnly={true} />
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.phone} label="Teléfono" readOnly={true} />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.manager} label="Gerente" readOnly={true} />
                                <InputFieldCustom col="col-4" width='100%' type="text" value={state?.email} label="Correo Notificador" readOnly={true} />
                            </div>
                            <BottomToolBar menu={<InternalMenu menus={menus} />} />
                            <br />
                        </div>
                    ) : (
                        <div class="container">
                        </div>
                    )}
                </div>) : (<AuthNotification openerror={openerror} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)
            }
        </div>
    );
}

export default RequestShow